import { SchedulesSearchProcedure } from '@/app/(main)/(pages)/busca/[slug]/_types/search-partner-data.type';

export type ExamCoverage = {
  matched: number;
  total: number;
  isFullCoverage: boolean;
};

export const getExamCoverage = (
  procedures: SchedulesSearchProcedure[],
  proceduresResearchedLength: number,
): ExamCoverage => {
  const matched = procedures.filter((procedure) => procedure.price !== undefined).length;

  return {
    matched,
    total: proceduresResearchedLength,
    isFullCoverage: matched === proceduresResearchedLength,
  };
};
